
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

var PersonChangeApplyPage = Vue.extend({})
Vue.component('personChangeApply-page', PersonChangeApplyPage)

export default {
name: 'PersonChangeApplyPage',
components: {
XTable,XButton,XDialog,Group,XInput,CellBox,Radio,PopupHeader,Popup,XTextarea
},
directives: {
TransferDom
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '',
info: {},
refRecordId: '',
refModule: '',
showToast: false,//弹窗-dialog

checkTreeShow: false,
treeData: [],//人员结构树
checkTreeSearchVal: '',//人员结构树搜索内容
checkTreeSearchResult: [],//人员结构树搜索结果
treeProps: {
children: 'children',
label: 'name'
},
checkDeptResult: {},//人员结构树-选择结果

employeeName: '',//人员结构树name
employeeNo: '',//工号
employeeId: '',//员工id
beforeJob: '',//现在职务
beforeDepartmentName: '',//现在部门
departmentId: '',
laterDepartmentName: '',
registerTime: '',//入职时间
positionLevelName: '',//职级

beforeMoney: '',//变动前工资总额
laterMoney: '',//变动后工资总额

treeType: '',
auditChoose1: '',
changesDescription: '',
signatureDate: '',

jobList: [],//职务
jobValue: '',
jobLabel: '',
jobId: '',//职务ID

turnoverList: [
{id:'0',name:'晋升'},
{id:'1',name:'降职'},
{id:'2',name:'调职'},
{id:'3',name:'免职'},
{id:'4',name:'复职'},
{id:'5',name:'调薪'},
{id:'6',name:'降薪'},
],//变动情况
turnoverValue: '',
turnoverLabel: '',
turnoverId: '',

positionLevelList: [],//变动情况
positionLevelValue: '',
positionLevelLabel: '',
positionLevelId: '',//变动情况ID

positionLevelList: [],//职级
positionLevelValue: '',
positionLevelLabel: '',
positionLevelId: '',//职级ID

selectModelFlag: false, //下拉选择弹框控制
selectModelTitle: '', //下拉选择弹框标题
selectModelData:[], //下拉选择弹框数据
selectModel: '',
wageAdjustment: '',//工资调整说明


treeData1: [],//组织结构树
checkTreeShow1: false,
checkTreeSearchVal1: '',//组织结构树搜索内容
checkTreeSearchResult1: [],//组织结构树搜索结果
treeProps1: {
children: 'children',
label: 'name'
},
checkDeptResultName1: '',//责任中心name
checkDeptResult1: {},//责任中心-选择结果


}
},
mounted () {
this.$emit('sendTitleToParent','人事变动申请');
this.getJob();
this.getPositionLevel();
this.axios({
url: this.baseUrl+'/wechat/personnelChange/changeApply',
method: 'get'
}).then((response) => {
this.info = response.data.obj;
this.refRecordId = response.data.refRecordId;
this.refModule = response.data.refModule;
}).catch((response) => {
this.$vux.loading.hide();
});
},
methods: {
showMsg (msg) {
this.$vux.alert.show({
title: msg
})
setTimeout(() => {
this.$vux.alert.hide()
}, 2000)
},
openDialog (v) {// 打开选择业务-dialog
this.showToast = true;
if(v === 'person'){
this.getDeptTree();
}else if(v === 'department'){
this.getDeptTree1();
}

},
getDeptTree () {//获取人员架构
this.axios({
url: this.baseUrl+'/wechat/staff/getOrgStaff',
method: 'get'
}).then((response) => {
this.treeData = response.data;
this.checkTreeShow = true;
}).catch((response) => {
this.$vux.loading.hide();
});
},
clearSearchResult () {//清空搜索栏
this.checkTreeSearchResult = [];
},
clearDeptResult () {//清除组织架构
this.employeeName = '';
this.checkDeptResult = {};
},
getArray (data,name) {//组织架构搜索-递归
for (var i in data) {
if (data[i].name == name || data[i].name.indexOf(name) != -1) {
this.checkTreeSearchResult.push(data[i]);
}else {
this.getArray(data[i].children, name);
}
}
},
addToTree (item) {//将搜索结果添加到树
let CheckedNodes = this.$refs.tree.getCheckedNodes();
CheckedNodes.push(item);
this.$refs.tree.setCheckedNodes(CheckedNodes);
this.checkTreeSearchResult = [];
},
getCheckedNodes() {//选择-人员架构树

let checkedPersonArr = this.$refs.tree.getCheckedNodes();

this.checkDeptResult = checkedPersonArr[0];
this.employeeName = this.checkDeptResult.name;
this.employeeId = this.checkDeptResult.id;
this.checkTreeShow = false;
this.showToast = false;
console.log('组织架构树',this.checkDeptResult,this.employeeName);
this.getStaffDetail();
},
getStaffDetail () {
this.axios({
url: this.baseUrl+'/wechat/staff/getStaffDetail?staffId='+this.employeeId,
method: 'get'
}).then((response) => {
console.log('getStaffDetail',response.data.staff);
this.employeeNo = this.checkDeptResult.numberCode;
this.beforeJob = response.data.staff.rankName;
this.beforeDepartmentName = response.data.staff.departmentName;
this.departmentId = response.data.staff.departmentId;
this.registerTime = response.data.staff.entryDate;
this.positionLevelName = response.data.staff.positionLevelName;
}).catch((response) => {
this.$vux.loading.hide();
});
},
treeSearch () {//提交-人员架构搜索按钮
this.checkTreeSearchResult = [];
let checkTreeSearchVal = this.checkTreeSearchVal;
let treeData = this.treeData;
if(checkTreeSearchVal!=''){
this.getArray(treeData,checkTreeSearchVal);
}
},
openSelectModelFlage(type,data){
console.log('openSelectModelFlage',type,data);
this.selectModelData = [];
if(type == 'job'){
this.selectModelTitle = '请选择职务';
this.selectModel = this.jobValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}else if(type == 'positionLevel'){
this.selectModelTitle = '请选择职级';
this.selectModel = this.positionLevelValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}else if(type == 'turnover'){
this.selectModelTitle = '请选择变动情况';
this.selectModel = this.turnoverValue;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}
this.selectModelFlag = true;
},
getLeaveType (value, label) {

this.accountUniId = value;

let isChange = value == this.selectModel ? false : true
if(this.selectModelTitle == '请选择职务'){
this.selectModel = this.jobValue = value;
this.jobLabel = label;
} else if(this.selectModelTitle == '请选择职级') {
this.selectModel = this.positionLevelValue = value;
this.positionLevelLabel = label;
} else if(this.selectModelTitle == '请选择变动情况'){
this.selectModel = this.turnoverValue = value;
this.turnoverLabel = label;
}
if(isChange){
this.selectModelFlag = false;
}
console.log(this.selectModel)
},

async getJob () {//获取职务

let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listValidRank',
method: 'get'
});
let list = res.data.list;
this.jobList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.jobList.push(list[i]);
}

},


async getPositionLevel () {//获取职级

let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listBaseDatas/POSITION_LEVEL',
method: 'get'
});

let list = res.data.list;
this.positionLevelList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.positionLevelList.push(list[i]);
}

},


getDeptTree1 () {//责任中心-获取组织架构
this.axios({
url: this.baseUrl+'/wechat/commonInterface/deptTree',
method: 'get'
}).then((response) => {
this.treeData1 = response.data;
this.checkTreeShow1 = true;
}).catch((response) => {
this.$vux.loading.hide();
});
},
treeSearch1 () {//提交-组织架构搜索按钮
this.checkTreeSearchResult1 = [];
let checkTreeSearchVal = this.checkTreeSearchVal1;
let treeData = this.treeData1;
if(checkTreeSearchVal!=''){
this.getArray1(treeData,checkTreeSearchVal);
}
},
getArray1 (data,name) {//组织架构搜索-递归
for (var i in data) {
if (data[i].name == name || data[i].name.indexOf(name) != -1) {
this.checkTreeSearchResult1.push(data[i]);
}else {
this.getArray1(data[i].children, name);
}
}
},
addToTree1 (item) {//将搜索结果添加到树
let CheckedNodes = this.$refs.tree.getCheckedNodes1();
CheckedNodes.push(item);
this.$refs.tree1.setCheckedNodes(CheckedNodes);
this.checkTreeSearchResult1 = [];
},
clearSearchResult1 () {//清空搜索栏
this.checkTreeSearchResult1 = [];
},
getCheckedNodes1() {//审批-组织架构树

let checkedPersonArr = this.$refs.tree1.getCheckedNodes();

this.checkDeptResult1 = checkedPersonArr[0];
this.checkDeptResultName1 = this.checkDeptResult1.name;
this.checkTreeShow1 = false;
this.showToast = false;
this.laterDepartmentName = this.checkDeptResult1.name
console.log('组织架构树',this.checkDeptResult1);
},
clearDeptResult1 () {//清除组织架构
this.checkDeptResultName1 = '';
this.checkDeptResult1 = {};
},

chooseDate () {//预计还款日期
let that = this;
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.signatureDate,
onConfirm (val) {
that.signatureDate = val;
}
})
},
chooseDate1 () {//入职日期
let that = this;
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.registerTime,
onConfirm (val) {
that.registerTime = val;
}
})
},
saveForm () {//保存
if(this.employeeName == ''){
this.showMsg('请补充必填信息');
return false;
}
this.$vux.loading.show({
text: '加载中'
});

let formData = new FormData();
formData.append("id",this.info.id);

if(this.businessName){

}

formData.append("employeeId",this.employeeId);
formData.append("employeeName",this.employeeName);
formData.append("employeeNo",this.employeeNo);
formData.append("job",this.beforeJob);
formData.append("registerTime",this.registerTime);
formData.append("departmentId",this.departmentId);
formData.append("departmentName",this.beforeDepartmentName);

formData.append("changesDescription",this.changesDescription);
formData.append("beforeDepartmentName",this.beforeDepartmentName);
formData.append("laterDepartmentName",this.laterDepartmentName);
formData.append("beforeJob",this.beforeJob);
formData.append("laterJob",this.jobLabel);
formData.append("beforePositionLevel",this.positionLevelName);
formData.append("positionLevel",this.positionLevelLabel);
formData.append("beforeMoney",this.beforeMoney);
formData.append("laterMoney",this.laterMoney);
formData.append("wageAdjustment",this.wageAdjustment);
formData.append("signatureDate",this.signatureDate);
formData.append("auditChoose1",this.turnoverValue);

this.axios({
url: this.baseUrl+'/wechat/personnelChange/saveForm',
method: 'post',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
},
data: formData,
}).then((response) => {
console.log('人事变动saveForm',response.data,this.saveStatus);
if(response.data.status == 0){//保存失败
this.$vux.loading.hide();
this.showMsg(response.data.msg);
}else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
this.startFlow();
}else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
this.$emit('sendStatusToParent',{status:1});
this.$vux.loading.hide();
}
}).catch((response) => {
this.$vux.loading.hide();
});
},
startFlow () {//发起
let startData = new FormData();
startData.append("id",this.info.id);
startData.append("flowId",this.info.flowId);
this.axios({
url: this.baseUrl+'/wechat/loan/startFlow',
method: 'post',
data: startData
}).then((response) => {
console.log('startFlow',response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if(response.data.status == 1){

this.$emit('sendStatusToParent',{
status:0,
id:response.data.taskId,
stepId:response.data.stepId
});
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
});

},
}
}



// WEBPACK FOOTER //
// ./src/components/launch/hr/personChangeApply.vue